<dx-box height="100%" width="100%" direction="col" class="cc-white-background te-config-container">
    <dxi-item baseSize="auto">
        <div *dxTemplate class="logo-container">
            <img [src]="ciraLogo" height="30" width="50" alt="CiraConnect" />
        </div>
    </dxi-item>
    <dxi-item baseSize="auto">
        <div *dxTemplate>
            <h2 class="page-heading cc-text-center dx-theme-border-color-as-background-color">
                {{ pageTitle }}
            </h2>
        </div>
    </dxi-item>
    <dxi-item [ratio]="1" *ngIf="!!timeExpenseSubmissionHistoryResult" [visible]="!!action && !status && !reportUrl">
        <div *dxTemplate class="time-expense-container top-padding te-config-content">
            <dx-box height="100%" width="100%" direction="col">
                <dxi-item baseSize="auto">
                    <div *dxTemplate>
                        <dx-form
                            width="100%"
                            height="100%"
                            [labelLocation]="defaultLabelLocation"
                            [colCountByScreen]="{ 'lg': 4, 'md': 2, 'sm': isLandscape ? 2 : 1, 'xs': isLandscape ? 2 : 1 }"
                            [(screenByWidth)]="getScreenByWidth"
                        >
                            <dxi-item>
                                <dxo-label text="Status"></dxo-label>
                                <div *dxTemplate>
                                    {{ timeExpenseSubmissionHistoryResult.status }}
                                </div>
                            </dxi-item>
                            <dxi-item>
                                <dxo-label text="Submitted By"></dxo-label>
                                <div *dxTemplate>
                                    {{ timeExpenseSubmissionHistoryResult.submittedByDisplayText }}
                                </div>
                            </dxi-item>
                            <dxi-item>
                                <dxo-label text="Submitted Date"></dxo-label>
                                <div *dxTemplate>
                                    {{ timeExpenseSubmissionHistoryResult.submittedDate | date: dateFormat }}
                                </div>
                            </dxi-item>
                            <dxi-item>
                                <dxo-label text="Reference"></dxo-label>
                                <div *dxTemplate>
                                    {{ timeExpenseSubmissionHistoryResult.referenceNumber }}
                                </div>
                            </dxi-item>
                            <dxi-item>
                                <dxo-label text="Total Amount"></dxo-label>
                                <div *dxTemplate>
                                    {{ timeExpenseSubmissionHistoryResult.totalAmount | ccCurrency }}
                                </div>
                            </dxi-item>
                            <dxi-item>
                                <dxo-label text="Reimbursable Amount"></dxo-label>
                                <div *dxTemplate>
                                    {{ timeExpenseSubmissionHistoryResult.reimbursableAmount | ccCurrency }}
                                </div>
                            </dxi-item>
                            <dxi-item>
                                <dxo-label text="From"></dxo-label>
                                <div *dxTemplate>
                                    {{ timeExpenseSubmissionHistoryResult.fromDate | date: dateFormat }}
                                </div>
                            </dxi-item>
                            <dxi-item>
                                <dxo-label text="To"></dxo-label>
                                <div *dxTemplate>
                                    {{ timeExpenseSubmissionHistoryResult.toDate | date: dateFormat }}
                                </div>
                            </dxi-item>
                        </dx-form>
                    </div>
                </dxi-item>
                <dxi-item [ratio]="1">
                    <div *dxTemplate class="bottom-padding top-padding">
                        <dx-tabs
                            #expenseTabs
                            class="cc-tabs"
                            [width]="isSmallScreen ? '90%' : timeExpenseSubmissionHistoryResult.tabItems.length * 120"
                            [dataSource]="timeExpenseSubmissionHistoryResult.tabItems"
                            [(selectedItem)]="timeExpenseSubmissionHistoryResult.selectedTab"
                        ></dx-tabs>

                        <app-time-expense-report-master-detail-grid
                            [userId]="userId"
                            [submissionId]="submissionId"
                            [selectedTab]="timeExpenseSubmissionHistoryResult.selectedTab"
                            [selectedExpenseTabDatail]="getSelectedTabData()"
                            (onNoteUpdate)="onNoteUpdate()"
                        ></app-time-expense-report-master-detail-grid>
                    </div>
                </dxi-item>
                <dxi-item baseSize="auto">
                    <div *dxTemplate class="top-padding">
                        <dx-box height="100%" width="100%" direction="row">
                            <ng-container *ngIf="allowDeny">
                                <dxi-item baseSize="auto">
                                    <div *dxTemplate class="input-label">
                                        Deny Reason:
                                        <span class="cc-required-text">*</span>
                                    </div>
                                </dxi-item>
                                <dxi-item [ratio]="1">
                                    <div *dxTemplate class="text-input">
                                        <dx-text-box [(value)]="reason"></dx-text-box>
                                    </div>
                                </dxi-item>
                            </ng-container>
                            <dxi-item *ngIf="allowApprove && !allowDeny" [ratio]="1"></dxi-item>
                            <dxi-item baseSize="auto">
                                <div *dxTemplate>
                                    <dx-button
                                        [visible]="allowDeny"
                                        type="default"
                                        stylingMode="contained"
                                        hint="Confirm Deny"
                                        text="Confirm Deny"
                                        [icon]="iconCross"
                                        (onClick)="onSubmit()"
                                    ></dx-button>
                                    <dx-button
                                        [visible]="allowApprove"
                                        type="success"
                                        stylingMode="contained"
                                        hint="Confirm Approve"
                                        text="Confirm Approve"
                                        [icon]="iconCheck"
                                        (onClick)="onSubmit()"
                                    ></dx-button>
                                </div>
                            </dxi-item>
                        </dx-box>
                    </div>
                </dxi-item>
            </dx-box>
        </div>
    </dxi-item>

    <dxi-item [ratio]="1" [visible]="!action && !status && !!reportUrl">
        <div *dxTemplate>
            <app-time-expense-submission-report-viewer
                [source]="reportUrl"
                [loader]="loadingVisible"
            ></app-time-expense-submission-report-viewer>
        </div>
    </dxi-item>

    <dxi-item baseSize="auto" [visible]="!!status">
        <div *dxTemplate class="time-expense-container">
            <div class="error-container">
                <i *ngIf="status?.iconText === 'FLAG_RED'" [ngClass]="iconFlag" class="fa-2x cc-red-icon"></i>
                <i *ngIf="status?.iconText === 'ALERT'" [ngClass]="iconWarn" class="fa-2x cc-yellow-icon"></i>
                <i *ngIf="status?.iconText === 'SUCCESS'" [ngClass]="iconCheck" class="fa-2x cc-green-icon"></i>
                <h2>
                    <strong>{{ status?.statusHeader }}</strong>
                </h2>
            </div>

            <p class="top-padding">
                {{ status?.statusMsg }}
            </p>
        </div>
    </dxi-item>
    <dxi-item baseSize="auto" [visible]="!action && !status && !reportUrl">
        <div *dxTemplate class="time-expense-container">
            <p>{{ status?.statusMsg }}</p>

            <p>
                Expense report download should start automatically, If not please
                <span class="cc-hyper-link" (click)="downloadReport()">click here</span>
                &nbsp;
                <i [ngClass]="iconFile"></i>
                &nbsp; to view the expense report.
            </p>
        </div>
    </dxi-item>
</dx-box>

<dx-load-panel *ngIf="loadingVisible" [position]="{ of: 'body' }" [visible]="loadingVisible"></dx-load-panel>
